import "./workflow-options.scss"
import React, { SetStateAction, useEffect, useState } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleArrowLeft, faEdit, faEllipsis, faFile, faTrash } from "@fortawesome/free-solid-svg-icons"
import api, { CRM_API_URI } from "api";
import { useParams } from "react-router-dom";

interface props{
    setActiveViewWorkflow:any,
    setActiveX:any,
    setActiveY:any,
    Id:any,
    getWorkflow:any,
    cols:any,
    setCols:any
   
}

function WorkflowOptions({setActiveViewWorkflow,setActiveX,setActiveY,Id,getWorkflow,cols,setCols}:props) {
  const params: any = useParams();
  const pos={
    top: setActiveY,
    left :setActiveX
  }
  const [activeWorkflowEdit,setActiveWorkflowEdit]=useState<boolean>(false);


  const DeleteGroup=()=>{
    
    
    let newVals=cols;
    if(Id!==999999999999){
      api.reactionLists.deleteWorkflowGroup(Id);
      getWorkflow();
    }
    newVals.forEach(
      (col:any)=>{
        if(col.Id==Id){
          newVals.splice(newVals.indexOf(col),1);
        }
      })
      console.log(newVals);
      setCols(newVals);
    setActiveViewWorkflow(false);
  }

  const setAsDefault=async ()=>{
    let workflow= await api.reactionLists.getWordflow(params.reactionListId);
    api.reactionLists.setAsDefault(workflow.Id,Id);
    getWorkflow();
    setActiveViewWorkflow(false);
  }

  const edit=()=>{
    setActiveWorkflowEdit(true);
  }



  return (
    <>
    {activeWorkflowEdit? 
    (<div style={pos} className="options-workflow-container">
       <input  placeholder="Name"></input>
          <div className="nw-btn-split">
                <button onClick={()=>setActiveWorkflowEdit(false)} >Cancel</button>
                <button >Rename</button>
          </div>
    </div>)
    :( <div style={pos} className="options-workflow-container">
      <button onClick={DeleteGroup}> <FontAwesomeIcon  icon={faTrash} />Delete</button>
      <button onClick={edit}> <FontAwesomeIcon icon={faEdit} /> Edit</button>
      <button onClick={setAsDefault}> <FontAwesomeIcon  icon={faFile} /> Set As Default</button>    
    </div>)}
    </>
)}

export default WorkflowOptions